
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { useEffect, useState } from 'react';
import { TIMES } from '../utils/dates';

export default function TimePicker(props) {

    const [startTime, setStartTime] = useState('')
    const [endTime, setEndTime] = useState('')

    const handleStartTime = value => {
        setStartTime(value)
        props.setTime(value, true)
    }

    const handleEndTime = value => {
        setEndTime(value)
        props.setTime(value, false)
    }

    useEffect(() => {
        if (props.prevTime.start !== '0000') {
            setStartTime(props.prevTime.start)
        }
        if (props.prevTime.end !== '0000') {
            setEndTime(props.prevTime.end)
        }
    }, [props.prevTime])

    return (
        <>
            <FormControl fullWidth sx={{ m: 1 }}>
                <InputLabel>Desde</InputLabel>
                <Select
                    value={startTime}
                    onChange={e => handleStartTime(e.target.value)}
                    disabled={props.disabled}
                    label="Desde"
                >
                    {TIMES.map(elem => {
                        return (
                            <MenuItem value={elem} key={elem}>
                                {elem.slice(0, 2) + ':' + elem.slice(2,)}
                            </MenuItem>
                        )
                    })}
                </Select>
            </FormControl>
            <FormControl fullWidth sx={{ m: 1 }}>
                <InputLabel>Hasta</InputLabel>
                <Select
                    value={endTime}
                    onChange={e => handleEndTime(e.target.value)}
                    disabled={props.disabled}
                    label="Hasta"
                >
                    {TIMES.map(elem => {
                        return (
                            <MenuItem value={elem} key={elem}>
                                {elem.slice(0, 2) + ':' + elem.slice(2,)}
                            </MenuItem>
                        )
                    })}
                </Select>
            </FormControl>
        </>
    )
}